import { ReactElement } from "react";
import { SimpleGrid } from "@chakra-ui/react";

import { DesktopOnly, MobileOnly } from "components/BreakpointVisibility";
import { useRequestOrderSelectOptionsStack } from "hooks/api/requestOrder";
import {
  CreatableTextFormInput,
  DatePickerFormInput,
  NumberFormInput,
} from "components/inputs";
import { requestOrderInvalidNumberInputCharacters } from "forms/RequestOrderForm";
import {
  ShipToSelect,
  ModeSelect,
  ShipFromSelect,
  SalesTermsSelect,
} from "./requestOrderSelects";
import { NO_MORE_ORDERS_THRESHOLD } from "util/constants";

const RequestOrderSelectInputs = () => {
  useRequestOrderSelectOptionsStack();
  return (
    <>
      <ShipFromSelect id="shipFrom" />
      <ModeSelect id="mode" />
      <SalesTermsSelect id="salesTerms" />
      <ShipToSelect id="shipTo" />
    </>
  );
};

export type RequestOrderFormInputProps = {
  minShipDate?: Date;
  maxShipDate?: Date;
  unitOfMeasure: string;
};

const minimumOrderQuantity = NO_MORE_ORDERS_THRESHOLD;

const RequestOrderInputs = ({
  unitOfMeasure,
  minShipDate,
  maxShipDate,
}: RequestOrderFormInputProps) => (
  <>
    <RequestOrderSelectInputs />
    <NumberFormInput
      id="quantityPerOrder"
      label={`Quantity per Order (min of ${minimumOrderQuantity} ${unitOfMeasure})`}
      uom={unitOfMeasure}
      min={minimumOrderQuantity}
      invalidInputCharacters={requestOrderInvalidNumberInputCharacters}
    />
    <DatePickerFormInput
      id="requestedShipDate"
      label="Requested Ship Date"
      minDate={minShipDate}
      maxDate={maxShipDate}
    />
  </>
);

const RequestOrderFormInputs = (
  props: RequestOrderFormInputProps
): ReactElement => (
  <>
    <DesktopOnly>
      <SimpleGrid columns={3} spacing={4}>
        <RequestOrderInputs {...props} />
      </SimpleGrid>
    </DesktopOnly>
    <MobileOnly>
      <RequestOrderInputs {...props} />
    </MobileOnly>
    <CreatableTextFormInput
      id="poNumber"
      label="PO # (optional)"
      placeholder="For unique PO number, separate by commas ex: WA3258742,  WA3258745, WA3258746. Press Enter when done."
    />
  </>
);

export default RequestOrderFormInputs;
